import { render, staticRenderFns } from "./TaskTitle.vue?vue&type=template&id=2c222222&scoped=true"
import script from "./TaskTitle.vue?vue&type=script&lang=js"
export * from "./TaskTitle.vue?vue&type=script&lang=js"
import style0 from "./TaskTitle.vue?vue&type=style&index=0&id=2c222222&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c222222",
  null
  
)

export default component.exports